import angular from 'angular';
import ReplyMessageDialogComponent from './reply-message-dialog-component';

export default angular.module('reply-message-dialog', []).component('replyMessageDialog', new ReplyMessageDialogComponent());



// WEBPACK FOOTER //
// ./src/modules/message/components/reply-message-dialog/reply-message-dialog-module.js